'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var LOGIN_REQUEST = exports.LOGIN_REQUEST = 'LOGIN_REQUEST';
var LOGIN_SUCCESS = exports.LOGIN_SUCCESS = 'LOGIN_SUCCESS';
var LOGIN_FAILURE = exports.LOGIN_FAILURE = 'LOGIN_FAILURE';
var LOGOUT = exports.LOGOUT = 'LOGOUT';

var loginSuccess = exports.loginSuccess = function loginSuccess(token, expiresAt) {
  return {
    type: LOGIN_SUCCESS,
    token: token,
    expiresAt: expiresAt
  };
};

var loginFailure = exports.loginFailure = function loginFailure(error) {
  return {
    type: LOGIN_FAILURE,
    error: error
  };
};

var login = exports.login = function login(config) {
  return {
    type: LOGIN_REQUEST,
    config: config
  };
};

var logout = exports.logout = function logout() {
  return {
    type: LOGOUT
  };
};